module.exports = __webpack_public_path__ + "static/media/spinButton.316c47c4.png";